module.exports = __webpack_public_path__ + "img/reaction4.bdf1163f.png";